var PI2 = Math.PI * 2;

function normalizeRadian(angle) {
  angle %= PI2;

  if (angle < 0) {
    angle += PI2;
  }

  return angle;
}

exports.normalizeRadian = normalizeRadian;


//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/contain/util.js
// module id = 212
// module chunks = 1